import { createContext } from 'preact';
import { StateUpdater } from 'preact/hooks';

export interface Customer {
  ID: any;
  Code: string;
  Name: string;
}

export interface Contact {
  ID: any;
  FullName: string;
}

export interface SalesRep {
  ID: any;
  Code: string;
  Name: string;
}

export interface Branch {
  ID: any;
  Code: string;
  Description: string;
}

export interface Currency {
  ID: any;
  Code: string;
  Description: string;
}

export interface DeliveryInstructions {
  ID: any;
}

export interface DeliveryAgent {
  ID: any;
  Code: string;
  Description: string;
}

export interface DeliveryAgentService {
  ID: any;
  Description: string;
}

export interface DeliveryTaxRate {
  ID: any;
  Code: string;
  Description: string;
}

export interface Product {
  ID: any;
  Code: string;
  Description: string;
}

export interface TaxRate {
  ID: any;
  Code: string;
  Description: string;
}

export interface PriceSource {
  Value: string;
  Name: string;
}

export interface InvoiceItem {
  ID: any;
  Product: Product;
  Description: string;
  Quantity: number;
  NetPrice: number;
  GrossPrice: number;
  NetAmount: number;
  TaxRate: TaxRate;
  TaxAmount: number;
  GrossAmount: number;
  PriceSource: PriceSource;
}

export interface SalesLedgerEntry {
  ID: any;
  Number: string;
  Unallocated: number;
}

export interface SalesInvoicesOrdCreditNote {
  ID: any;
  UpdatedOn: string;
  CreatedOn: string;
  Date: string;
  DueDate: string;
  Number: string;
  AlternateReference: string;
  Customer: Customer;
  Contact: Contact;
  SalesRep: SalesRep;
  Branch: Branch;
  Currency: Currency;
  DeliveryInstructions: DeliveryInstructions;
  DeliveryAgent: DeliveryAgent;
  DeliveryAgentService: DeliveryAgentService;
  DeliveryNetAmount: number;
  DeliveryTaxRate: DeliveryTaxRate;
  DeliveryTaxAmount: number;
  DeliveryGrossAmount: number;
  NetAmount: number;
  TaxAmount: number;
  GrossAmount: number;
  Items: InvoiceItem[];
  SalesLedgerEntry: SalesLedgerEntry;
}

export interface StatementItem {
  Date: Date;
  SalesInvoices?: SalesInvoicesOrdCreditNote;
  SalesCreditNotes?: SalesInvoicesOrdCreditNote;
}

export interface SearchInvoiceData {
  StatementItems: StatementItem[];
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

export interface SearchInvoiceProps {
  page: number;
  limit: number;
  type: 'BOTH' | 'CREDITS' | 'INVOICES';
  months: number;
}

interface SelectedInvoice {
  id: string;
  value: number;
}

export interface InvoicesProps {
  form?: HTMLFormElement;
  items?: InvoiceItem[];
  setItems?: StateUpdater<InvoiceItem[]>;
  search?: SearchInvoiceProps;
  setSearch?: StateUpdater<SearchInvoiceProps>;
  selectedInvoices?: SelectedInvoice[];
  setSelectedInvoices?: StateUpdater<SelectedInvoice[]>;
  selectedCredits?: SelectedInvoice[];
  setSelectedCredits?: StateUpdater<SelectedInvoice[]>;
  handleFreshSearch?: (
    searchdata: Partial<SearchInvoiceProps>
  ) => Promise<{
    data: any;
    error: any;
  }>;
}

export const Invoices = createContext<InvoicesProps>({
  search: {
    page: 0,
    limit: 8,
    type: 'BOTH',
    months: 12,
  },
  items: [],
  setItems: undefined,
});
